import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react'
import styles from './BotAndDatasetList.module.css'
import classNames from 'classnames'
import { Radio, Typography } from 'antd'
import { useDispatch } from 'react-redux'
import HeaderBar from './HeaderBar'
import BotList from './BotList'
import DatasetList from './DatasetList'
const { Text } = Typography
// export default function BotAndDatasetList(props) {
const BotAndDatasetList = forwardRef((props, ref) => {
  const dispatch = useDispatch()
  const botListRef = useRef(null)
  function getBotListFn() {
    if(botListRef.current){
      botListRef.current.getBotListFn()
    }
  }

  const datasetListRef = useRef(null)
  function getDatasetListFn() {
    if(datasetListRef.current){
      datasetListRef.current.getDatasetListFn()
    }
  }

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {}
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  useImperativeHandle(ref, () => ({
    getBotListFn() {
      getBotListFn()
    },
    getDatasetListFn() {
      getDatasetListFn()
    },
  }))
  return (
    <div className={styles.background}>
      <HeaderBar
        createBot={props.createBotMethod}
        createDataset={props.createDatasetMethod}
        confirmSearch={(value) => {
          props.globalSearch(value, 3)
        }}
        type = {props.type}
      />
      <div className={styles.titleBox}>
        项目
        <Radio.Group
          value={props.type}
          options={[
            { value: 1, label: '智能体管理' },
            { value: 2, label: '知识库管理' },
          ]}
          style={{ marginLeft: 30 }}
          onChange={(e) => {
            props.changeType(e.target.value)
          }}
        />
        {/* <span
          className={styles.backButton}
          onClick={props.backMethod.bind(null, false)}
        >
          返回上一级 &lt;&lt;
        </span> */}
      </div>
      {props.type == 1 ? (
        <BotList
          clickBotItem={props.clickBotItem}
          backMethod={props.backMethod}
          editMethod={props.editMethod}
          getEduBotList={() =>{
            props.getEduBotList()
          }}
          ref={botListRef}
          shareBotItem={props.shareBotItem}
        />
      ) : <DatasetList
        clickDatasetItem={props.clickDatasetItem}
        backMethod={props.backMethod}
        editMethod={props.editMethod}
        ref={datasetListRef}
      />}
    </div>
  )
})
export default BotAndDatasetList
